import { render, staticRenderFns } from "./indexChat.vue?vue&type=template&id=15b33763&scoped=true"
import script from "./indexChat.vue?vue&type=script&lang=js"
export * from "./indexChat.vue?vue&type=script&lang=js"
import style0 from "./indexChat.vue?vue&type=style&index=0&id=15b33763&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b33763",
  null
  
)

export default component.exports